import { render } from "./ogpoSlider.vue?vue&type=template&id=a8a9589c&scoped=true"
import script from "./ogpoSlider.vue?vue&type=script&lang=js"
export * from "./ogpoSlider.vue?vue&type=script&lang=js"

import "./ogpoSlider.vue?vue&type=style&index=0&id=a8a9589c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8a9589c"]])

export default __exports__